<template>
    <el-timeline>
        <el-timeline-item v-for="(item, index) in timeline" :key="index" :timestamp="timestampLabel(item)" type="primary"
            placement="top">
            <div class="d-flex flex-column gap-2">
                <h5><img v-if="item.icon" :src="item.icon" alt="icon" /> {{ item.title }}</h5>
                <p>{{ item.description }}</p>
            </div>
        </el-timeline-item>
    </el-timeline>
</template>

<script>

export default {
    name: 'call-timeline',

    props: {
        timeline: {
            required: true,
            type: Array,
        }
    },

    methods: {
        timestampLabel(item) {
            const duration = item.duration
            const datetime = item.datetime
            let label = ''
            if (duration) {
                label += this.$options.filters.fixFullLongDuration(duration)
            }
            if (datetime) {
                if (label) {
                    label += ' | '
                }
                label += this.$options.filters.fixTimelineDateTime(datetime)
            }
            return label
        }
    }
}
</script>
